import { GetProjectFile } from 'Infrastructure/Service/ProjectService'
import { createProjectEntry, retrieveBlob, removeStore, exists } from 'Application/LocalStorage/IndexedDBHandler'
import { setPhase, setSubProgress, setError, INIT_PHASES } from 'Domain/Scene/Manager/InitializationOrchestrator'

/**
 * Project Storage Adapter
 */

export let 
    encodeBase64 = string => window.btoa(unescape(encodeURIComponent( string ))) ,
    validateManager = (json) => {return {
        type: 'validation',
        ref: json,
        consultation: encodeBase64( 'project-'+json.sk )
    }},
    nullManager = () => { return { type: null } },
    projectManager = (json) => exists( json ).then( exist => {
        let 
            referenceFormat = JSON.parse(json.Reference.format),
            projectDTO = {
                type: 'consultation',
                caseId: json.designation,
                store: json.sk,
                hash: json.Reference.hash,
                format: referenceFormat,
                actions: encodeBase64( 'validation-'+json.sk )
            }

        return ( exist && referenceFormat.gltfSize ) ?
            retrieveBlob( {project: projectDTO} ).then(
                charge => {
                    if ( parseInt(referenceFormat.gltfSize) !== parseInt( charge.size) ) {
                        return removeStore( projectDTO.store ).then( () => setupProject( json, projectDTO ).then( projectDto => projectDto ) )
                    }
                    setPhase(INIT_PHASES.PROJECT_STORING)
                    return projectDTO 
                }
            ):
            exist ?
                (setPhase(INIT_PHASES.PROJECT_STORING), projectDTO):
                setupProject( json, projectDTO ).then( projectDto => projectDto )
    }) ,
    setupProject = (json, projectDTO) => {
        setPhase(INIT_PHASES.PROJECT_DOWNLOADING)
        return new Promise ( (resolve, reject) => GetProjectFile( json.Reference.hash )
            .then(response => {

                if (!response.ok) {
                    throw Error(response.status+' '+response.statusText)
                }

                // ensure ReadableStream is supported
                if (!response.body) {
                    throw Error('ReadableStream not yet supported in this browser.')
                }

                let loaded = 0,
                total = response.headers.get('Pragma')

                return new Response(
                    new ReadableStream({
                        start(controller) {
                            const reader = response.body.getReader()
                            read()
                            function read() {
                                reader.read().then(({done, value}) => {
                                    if (done) {
                                        controller.close()
                                        return;
                                    }
                                    loaded += value.byteLength

                                    const percent = parseInt(loaded*100/total)
                                    setSubProgress(percent)

                                    controller.enqueue(value)
                                    read()
                                    }).catch(error => {
                                        console.error(error)
                                        controller.error(error)
                                    })
                            }
                        }
                    })
                )
            })
            .then( response => response.ok ?
                response.blob():
                null
            )
            .then( blob => {
                setPhase(INIT_PHASES.PROJECT_STORING)
                return createProjectEntry( json, new Blob([blob]) ).then( () =>
                    resolve( projectDTO )
                )
            })
            .catch( error => {
                setError('project data not valid')
                console.error("Error fetching data: ", error)
            } )
            .finally()
    )}